@if (product) {
  <rt-product-order-header
    [breadcrumbs]="breadcrumbs"
    [header]="'app.pricing.product_order.step_header_billing' | translate"
    margin-bottom-large
  ></rt-product-order-header>

  <rt-product-order-summary
    [product]="product"
    [price]="price"
    [paymentInterval]="interval"
    [slots]="slots"
    [companyName]="companyName"
    [addons]="addons"
    [style.display]="'block'"
    margin-bottom
  ></rt-product-order-summary>

  <rt-box variant="vertical">
    <div layout-horizontal>
      <rt-billing-address-form
        [chargebeeEntity]="pricingModel.chargebeeEntity"
        [formValue]="$any(billingInformation)"
        [selectedCurrency]="product.currency"
        (currencyChanges)="changeCurrency($event)"
        margin-right
      ></rt-billing-address-form>
      <rt-billing-contact-form
        [formValue]="$any(billingInformation)"
        [fields]="$any(billingContactFields)"
        [currentUserId]="currentUserId"
      ></rt-billing-contact-form>
    </div>

    @if (slots && slotsUsed > slots) {
      <rt-message variant="context-warning" margin-bottom>
        <div layout-horizontal>
          <rt-icon
            name="warning"
            size="medium"
            colorToken="colorIconWarningDefault"
            margin-right-small-x
          ></rt-icon>

          <p>
            <strong>{{
              'app.pricing.product_order.slots_message.text'
                | translate: { slots_used: slotsUsed, product_slots: slots }
            }}</strong>
            <br />
            <span class="message-link" (click)="addMoreSlotsDialog()">{{
              'app.pricing.product_order.slots_message.add_slots_link' | translate
            }}</span>
            {{ 'app.common.or' | translate }}
            <span class="message-link" (click)="contactSupport()">{{
              'app.common.contact_support' | translate
            }}</span>
          </p>
        </div>
      </rt-message>
    }

    @if (error) {
      <rt-message variant="context-error">
        <div layout-horizontal>
          <rt-icon
            name="warning"
            size="medium"
            colorToken="colorIconCriticalDefault"
            margin-right-small-x
          ></rt-icon>

          <p>
            @if (error.title) {
              <strong>{{ error.title }}</strong>
              <br />
            }
            {{ error.description }}
            @if (error.withContact) {
              <span class="message-link" (click)="contactSupport()">
                {{ 'app.common.contact_our_support' | translate }}
              </span>
            }
          </p>
        </div>
      </rt-message>
    }
  </rt-box>

  <div layout-horizontal margin-top layout-justify-flex-end>
    <rt-button [routerLink]="'../select-product'" variant="plain">
      {{ 'app.common.go_back' | translate }}
    </rt-button>
    <rt-button
      (click)="next()"
      [disabled]="!valid || proceeding"
      [loading]="proceeding"
      variant="primary"
      margin-left-small
    >
      {{ 'app.common.continue' | translate }}
    </rt-button>
  </div>
} @else {
  <rt-spinner></rt-spinner>
}

<ng-template #loading>
  <rt-spinner></rt-spinner>
</ng-template>
